"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertEditedRCM = exports.makeConsiderationResults = exports.CELL_STYLE_E = exports.CELL_STYLE_D = exports.CELL_STYLE_C = exports.CELL_STYLE_B = exports.CELL_STYLE_A = exports.CellColor = exports.CecllVerticalAlignment = exports.CellHorizontalAlignment = void 0;
var lodash_1 = __importDefault(require("lodash"));
var Translation_1 = require("../Translation");
var CellHorizontalAlignment;
(function (CellHorizontalAlignment) {
    CellHorizontalAlignment["left"] = "left";
    CellHorizontalAlignment["right"] = "right";
    CellHorizontalAlignment["center"] = "center";
})(CellHorizontalAlignment = exports.CellHorizontalAlignment || (exports.CellHorizontalAlignment = {}));
var CecllVerticalAlignment;
(function (CecllVerticalAlignment) {
    CecllVerticalAlignment["top"] = "top";
    CecllVerticalAlignment["middle"] = "middle";
    CecllVerticalAlignment["bottom"] = "bottom";
})(CecllVerticalAlignment = exports.CecllVerticalAlignment || (exports.CecllVerticalAlignment = {}));
var CellColor;
(function (CellColor) {
    CellColor["lightGreyColorHex"] = "fffafafa";
    CellColor["lightBlueColorHex"] = "ffe6f7ff";
    CellColor["lightGreenColorHex"] = "ffeefdec";
    CellColor["lightYellowColorHex"] = "fffff8f0";
})(CellColor = exports.CellColor || (exports.CellColor = {}));
function getCellStyle(isBold, backgroundColor, alignmentHorizontal, alignmentVertical) {
    return {
        style: { font: { bold: isBold } },
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: backgroundColor }
        },
        alignment: { horizontal: alignmentHorizontal, vertical: alignmentVertical }
    };
}
exports.CELL_STYLE_A = getCellStyle(true, CellColor.lightGreyColorHex, CellHorizontalAlignment.center, CecllVerticalAlignment.middle);
exports.CELL_STYLE_B = getCellStyle(true, CellColor.lightBlueColorHex, CellHorizontalAlignment.center, CecllVerticalAlignment.middle);
exports.CELL_STYLE_C = getCellStyle(true, CellColor.lightGreenColorHex, CellHorizontalAlignment.left, CecllVerticalAlignment.middle);
exports.CELL_STYLE_D = getCellStyle(false, CellColor.lightYellowColorHex, CellHorizontalAlignment.left, CecllVerticalAlignment.middle);
exports.CELL_STYLE_E = getCellStyle(true, CellColor.lightGreyColorHex, CellHorizontalAlignment.left, CecllVerticalAlignment.middle);
function makeConsiderationResults(considerations) {
    var rows = [];
    lodash_1.default.forEach(considerations, function (consideration, index) {
        lodash_1.default.forEach(consideration, function (value, key) {
            var _a, _b;
            var newRow = {
                description: '통제활동 설계평가',
                cells: index === 0
                    ? [{ style: exports.CELL_STYLE_A, value: '통제활동\n설계평가' }]
                    : [{ style: exports.CELL_STYLE_A, value: '' }]
            };
            if (key === 'title') {
                (_a = newRow.cells).push.apply(_a, [
                    {
                        style: exports.CELL_STYLE_B,
                        value: consideration.title,
                        cellSize: 6
                    },
                    {
                        style: exports.CELL_STYLE_A,
                        value: '평가 결론'
                    },
                    {
                        key: "content.data.considerations[".concat(index, "].result")
                    }
                ]);
            }
            else {
                (_b = newRow.cells).push.apply(_b, [
                    {
                        style: exports.CELL_STYLE_C,
                        value: consideration.content,
                        cellSize: 3
                    },
                    {
                        key: "content.data.considerations[".concat(index, "].content"),
                        cellSize: 5
                    }
                ]);
                newRow.height = 120;
            }
            rows.push(newRow);
        });
    });
    // Vertical Merge
    rows[0].rowSize = considerations.length * 2;
    return rows;
}
exports.makeConsiderationResults = makeConsiderationResults;
function convertEditedRCM(editRCM) {
    var rows = [
        {
            description: "\uD5E4\uB4DC\uB77C\uC778 - ".concat(editRCM.headline),
            height: 35,
            cells: [
                {
                    style: exports.CELL_STYLE_A,
                    value: "".concat(editRCM.headline),
                    cellSize: 4
                }
            ]
        }
    ];
    lodash_1.default.forEach(editRCM.contents, function (content) {
        if (content.PRC === 'control' && content.key === 'id') {
            rows.push({
                description: "\uB0B4\uC6A9 - ".concat(editRCM.headline),
                cells: [
                    {
                        style: exports.CELL_STYLE_A,
                        value: (0, Translation_1.getKoName)(content.PRC, content.key)
                    },
                    {
                        style: exports.CELL_STYLE_E,
                        key: "content.".concat(content.PRC, ".").concat(content.key)
                    },
                    {
                        style: exports.CELL_STYLE_A,
                        value: '수정 불가',
                        cellSize: 2
                    }
                ]
            });
            return;
        }
        rows.push({
            description: "\uB0B4\uC6A9 - ".concat(editRCM.headline),
            height: lodash_1.default.get(content, 'rowHeight', 15),
            cells: [
                {
                    style: exports.CELL_STYLE_A,
                    value: (0, Translation_1.getKoName)(content.PRC, content.key)
                },
                {
                    style: exports.CELL_STYLE_E,
                    key: "content.".concat(content.PRC, ".").concat(content.key)
                },
                {
                    style: exports.CELL_STYLE_D,
                    key: "state.weakStateData.".concat(content.PRC, ".").concat(content.key, ".content")
                },
                {
                    style: exports.CELL_STYLE_D,
                    key: "state.weakStateData.".concat(content.PRC, ".").concat(content.key, ".evidence")
                }
            ]
        });
    });
    return rows;
}
exports.convertEditedRCM = convertEditedRCM;
//# sourceMappingURL=ReportSheet.js.map